import { ScopesOfWork } from "./components/ScopesOfWork";
import { getFullPath, routes } from "../routes";
import { SearchField } from "../components";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

const DEFAULT_VIEW = "project";

export function ScopeOfWorkList() {
  const { view = DEFAULT_VIEW } = useParams();
  const [searchParams] = useSearchParams();

  const templates = view === "templates";
  const searchString = searchParams.get("search") ?? undefined;

  const navigate = useNavigate();

  function handleViewChanged(e: React.ChangeEvent<HTMLSelectElement>) {
    navigate(getFullPath(routes.scopeOfWork.list(e.target.value)));
  }

  return (
    <>
      <h3 className="mb-2">Scopes of Work</h3>
      <div className="d-flex flex-column-reverse flex-md-row justify-content-between mb-3">
        <SearchField />

        <div className="mb-2 mb-md-0">
          <select className="form-select" value={view} onChange={handleViewChanged}>
            <option value="project">Project</option>
            <option value="templates">Templates</option>
          </select>
        </div>
      </div>

      <ScopesOfWork filters={{ searchString, templates }} expanded={true} allowExpand={false} />
    </>
  );
}
